import * as appConstants from "applications/appConstants";

export const sponsorNoRatesMessage =
  process.env.REACT_APP_BRANDING === appConstants.BuildPerks
    ? "Monthly Reports are not set up for your company yet. Please contact Kristin at 612-359-1111 or kristing@buildperks.com for assistance."
    : "Monthly Reports are not set up for your company yet. Please contact Kristin at 612-359-1101 or kristing@buildersclubnorth.com for assistance.";

export const adminNoRatesMessage =
  "Unable to create monthly report. The sponsor may not have any rates set up.";
